module.exports = __webpack_public_path__ + "media/status-paused.6b46da6a.svg";